import { Types } from './types'

const initialState = {
    dataField: {
        rows: [],
        paging: {}
    },

}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
     
        case Types.SAVE_LIST_FIELD:
            return {
                dataField: action.payload
            }
      
        default:
            return { ...newState }
    }
}
export default reducer
